/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NurseDepartment from './nurse-department';
import NurseDepartmentDetail from './nurse-department-detail';
import NurseDepartmentUpdate from './nurse-department-update';
import NurseDepartmentDeleteDialog from './nurse-department-delete-dialog';

const NurseDepartmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NurseDepartment />} />
    <Route path="new" element={<NurseDepartmentUpdate />} />
    <Route path=":id">
      <Route index element={<NurseDepartmentDetail />} />
      <Route path="edit" element={<NurseDepartmentUpdate />} />
      <Route path="delete" element={<NurseDepartmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NurseDepartmentRoutes;
